function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.9198 5.57286C20.54 5.90923 21.1249 6.63512 21.5642 7.98457H22.3223L21.3747 2.67767H18.6364L19.9198 5.57286ZM12.8428 2.67767H1V7.41597L7.91791 14.2865L1 22.4364V24H20.9956L22.3223 16.0397H21.5168L20.9956 17.1769C20.2375 18.7879 19.5267 20.0198 17.7736 20.0198H5.64353L11.8507 12.6755L4.50634 5.33112H11.5844L12.8428 2.67767Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2389 7.42023C19.2217 7.43211 19.1693 7.44162 19.0982 7.38457C19.0346 7.33346 17.4401 6.06473 16.4043 5.24064V18.762H14.9772V5.29411L12.2785 7.3917C12.2489 7.4131 12.197 7.42736 12.1674 7.42736C12.1156 7.42736 12.1141 7.35605 12.1378 7.29901L15.4995 0.168468C15.6106 -0.0597077 15.7735 -0.0525762 15.8772 0.168468L19.2389 7.27049C19.2612 7.31327 19.2686 7.39741 19.2389 7.42023Z",
  fill: "#D18F1F"
});
function SvgSigmaUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigmaUp);
export default __webpack_public_path__ + "static/media/sigma-up.ee5b63894097d851fbc20a9e92352870.svg";
export { ForwardRef as ReactComponent };